export interface StockDetailTableModel {
  productId: number;
  productCode: string;
  productGroupName: string;
  salesProfitCentreCode: string;
  salesBranchCode: string;
  stockBranchCode: string;
  stockWarehouseCode: string;
  stockClass: { code: ''; color: '' };
  availableStock: number | null;
  availableNonSerialStock: number | null;
  availableSerialStock: number | null;
  onOrder: number | null;
  committed: number | null;
  total: number | null;
  eta: string | null;
  etaStatus: string;
  averageMonthSales: number | null; // this is whole year monthly average sales
  thisMonth: number | null;
  oneMonthAgo: number | null;
  twoMonthsAgo: number | null;
  threeMonthsAgo: number | null;
  fourMonthsAgo: number | null;
  fiveMonthsAgo: number | null;
  sixMonthsAgo: number | null;
  sevenMonthsAgo: number | null;
  eightMonthsAgo: number | null;
  nineMonthsAgo: number | null;
  tenMonthsAgo: number | null;
  elevenMonthsAgo: number | null;
  findMatched: boolean; // this is used for stock level and sales if find matched
  requestedQty: number | null;
  remainingQty: number | null;
  showRequestedQtyInput: boolean;
  isEdited: boolean;
  children: StockDetailTableModel[];
  showBold: boolean;
  levelNumber: number;
  comment: string | null;
  isStockBranchDifferentFromSalesBranch: boolean | null;
}

export enum TableRowLevel {
  ProfitCentreLevelRow = 0,
  BranchLevelRow = 1,
  WarehouseLevelRow = 2,
}